var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinedAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.5,
    height: 66.964,
    viewBox: "0 0 53.5 66.964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5404",
    "data-name": "Group 5404",
    transform: "translate(-683.98 -295.314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5403",
    "data-name": "Group 5403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(686 297.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M129.5,253.7c-.129-8.291-2.712-15.83-7.305-21.289a22.254,22.254,0,0,0-34.852,0c-4.588,5.453-7.17,12.981-7.3,21.262,2.594,1.3,13.331,6.3,24.73,6.3A55.029,55.029,0,0,0,129.5,253.7Z",
    transform: "translate(-80.04 -197.015)",
    fill: "none",
    stroke: "#90205d",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    cx: 12.368,
    cy: 12.368,
    r: 12.368,
    transform: "translate(12.362 0)",
    fill: "none",
    stroke: "#90205d",
    strokeWidth: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinedAccount);
export default __webpack_public_path__ + "static/media/linedAccount.7fb573ca.svg";
export { ForwardRef as ReactComponent };